import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import stripeApiService from '../../services/stripe-subscription.service';
import { fetchOrganizationDetails } from '../../reducers/authSlice';
import paymentSuccess from '../../assets/images/payment-success.png';
import paymentFailed from '../../assets/images/payment-failed.png';

function PaymentStatus() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sessionId = searchParams.get('session_id');

  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const confirm = async () => {
      if (!sessionId) {
        setErrorMessage('No session ID found. Please try again.');
        setIsLoading(false);
        return;
      }

      try {
        await stripeApiService.confirmCheckout(sessionId);
        setIsSuccess(true);
        await dispatch(fetchOrganizationDetails());
      } catch (err) {
        console.error('Checkout confirmation failed:', err);
        setErrorMessage('Payment could not be confirmed. Please contact support if you were charged.');
      } finally {
        setIsLoading(false);
      }
    };

    confirm();
  }, [sessionId, dispatch]);

  const handleGoToDashboard = () => {
    navigate('/landing', { replace: true });
  };

  if (isLoading) {
    return (
      <div className="container min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" />
          <p className="mt-3">Activating your subscription...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container min-vh-100 d-flex align-items-center justify-content-center">
      <div className="p-4" style={{ maxWidth: '500px' }}>
        <div className="text-center pt-2 mb-3">
          <img
            className="payment-img"
            alt={isSuccess ? 'Success' : 'Failed'}
            src={isSuccess ? paymentSuccess : paymentFailed}
          />
        </div>

        <div className="card-body pb-0 text-center">
          <h2 className={`payment-success-title ${isSuccess ? 'text-primary' : 'text-danger'}`}>
            {isSuccess ? 'Successful!' : 'Payment Error'}
          </h2>

          <p className="text-muted mb-4 payment-detail-text">
            {isSuccess
              ? 'Your subscription has been successfully activated. You now have full access to all features.'
              : errorMessage}
          </p>

          <div className="mt-4 d-flex flex-column align-items-center justify-content-center">
            {isSuccess ? (
              <button
                onClick={handleGoToDashboard}
                className="mb-3 width-auto px-4 btn btn-primary btn-lg"
              >
                Go to Dashboard
              </button>
            ) : (
              <button
                onClick={() => navigate('/subscription')}
                className="btn mb-3 btn-outline-danger btn-lg"
              >
                Try Again
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentStatus;
